import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import Button from '../button';
// eslint-disable-next-line yola/import/no-named-as-default
import Modal from '../modal';
import Render from '../render';
import Icon from '../icon';
import ButtonGroup from '../button-group';

function AlertDialog({
  width = 376,
  height = 220,
  content = null,
  offsetX = 0,
  offsetY = 0,
  onDismiss = null,
  handleCancel = null,
  captions: { title, description, dismiss, submit, descriptionLink },
  descriptionLinkHref = null,
  onSubmit = null,
  glyph = null,
  imgSrc = null,
  onDialogMainAction = null,
  onDialogCancel = null,
  minHeight = 220,
}) {
  const onDismissAction = () => {
    if (onDialogCancel) onDialogCancel();

    if (onDismiss) onDismiss();
  };

  const onCancelAction = () => {
    if (onDialogCancel) onDialogCancel();

    if (handleCancel) {
      handleCancel();
    } else if (onDismiss) {
      onDismiss();
    }
  };

  const onSubmitAction = () => {
    if (onDialogMainAction) onDialogMainAction();

    if (onSubmit) onSubmit();
  };

  const isContentPresented = Boolean(content);

  return (
    <Modal
      overlay="visible"
      centered
      resizable={false}
      draggable={false}
      className="ws-alert-dialog"
      width={width}
      height={height}
      minWidth={312}
      minHeight={minHeight}
      offsetX={offsetX}
      offsetY={offsetY}
      handleCancel={onCancelAction}
    >
      <Render if={Boolean(glyph) && !imgSrc}>
        <Icon glyph={glyph} size={24} className="ws-alert-dialog__icon" />
      </Render>
      <Render if={Boolean(imgSrc) && !glyph}>
        <img src={imgSrc} className="ws-alert-dialog__img" alt="" />
      </Render>
      <Text type="heading-5" className="ws-alert-dialog__title">
        {title}
      </Text>
      <div className="ws-alert-dialog__content">
        {!isContentPresented && (
          <React.Fragment>
            <Text theme="grey">{description} </Text>
            {Boolean(descriptionLink) && Boolean(descriptionLinkHref) && (
              <Text theme="grey">
                {/* eslint-disable-next-line yola/react/jsx-no-target-blank */}
                <a href={descriptionLinkHref} className="ws-alert-dialog__link" target="_blank">
                  {descriptionLink}
                </a>
              </Text>
            )}
          </React.Fragment>
        )}
        {isContentPresented && content}
      </div>
      <ButtonGroup className="ws-submit-dialog__buttons">
        <Render if={Boolean(onSubmit) && Boolean(submit)}>
          <Button stretch="block" size="large" onClick={onSubmitAction}>
            <span>{submit}</span>
          </Button>
        </Render>
        <Render if={Boolean(onDismiss) && Boolean(dismiss)}>
          <Button stretch="block" size="large" onClick={onDismissAction}>
            {dismiss}
          </Button>
        </Render>
      </ButtonGroup>
    </Modal>
  );
}

AlertDialog.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  minHeight: PropTypes.number,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  content: PropTypes.elementType,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    dismiss: PropTypes.string.isRequired,
    submit: PropTypes.string,
    descriptionLink: PropTypes.string,
  }).isRequired,
  descriptionLinkHref: PropTypes.string,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  glyph: PropTypes.string,
  handleCancel: PropTypes.func,
  imgSrc: PropTypes.string,
  onDialogMainAction: PropTypes.func,
  onDialogCancel: PropTypes.func,
};

export default AlertDialog;
